import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/promote/qr-codes")({
  // Component in lazy file for code splitting
});
